import { Dispatch } from 'redux';
import { InstrumentoEdicaoResponse } from 'common/genericTypes';
import { GETInstrumentosEdicao } from 'requests/instrumentoEdicao';
import { typedAction } from 'store/modules/base';

export interface InstrumentoEdicaoApiState {
  getInstrumentosEdicao(dispatch: Dispatch, filter?: any, stackRequest?: boolean): Promise<Array<InstrumentoEdicaoResponse>>;
}

const instrumentoEdicaoApiInicialState: InstrumentoEdicaoApiState = {
  getInstrumentosEdicao: GETInstrumentosEdicao,
};

enum InstrumentoEdicaoApiActionType {
  Update = 'instrumentoEdicaoApi/UPDATE',
  Reset = 'instrumentoEdicaoApi/RESET',
}

export const updateInstrumentoEdicaoApi = (state: InstrumentoEdicaoApiState) => {
  return typedAction(InstrumentoEdicaoApiActionType.Update, state);
};

export const resetInstrumentoEdicaoApi = () => {
  return typedAction(InstrumentoEdicaoApiActionType.Reset);
};

type InstrumentoEdicaoApiAction = ReturnType<typeof updateInstrumentoEdicaoApi | typeof resetInstrumentoEdicaoApi>;

export function instrumentoEdicaoApiReducer(
  state: InstrumentoEdicaoApiState = instrumentoEdicaoApiInicialState,
  action: InstrumentoEdicaoApiAction
): InstrumentoEdicaoApiState {
  switch (action.type) {
    case InstrumentoEdicaoApiActionType.Update:
      return { ...action.payload };
    case InstrumentoEdicaoApiActionType.Reset:
      return { ...instrumentoEdicaoApiInicialState };
    default:
      return state;
  }
}